
/*
    Author - Sajith Henarath
    sajith_h@epiclanka.net
*/
export class ChangeStageFlowModel {
  workflowStageCode: string;
  description: string;
  nextWorkFlowCode: string;
  status: string;
  user: string;
  url: string;

  constructor(workflowStageCode: string, description: string, nextWorkFlowCode: string, status: string, user: string, url: string) {
    this.workflowStageCode = workflowStageCode;
    this.description = description;
    this.nextWorkFlowCode = nextWorkFlowCode;
    this.status = status;
    this.user = user;
    this.url = url;
  }
}
